import axios, { encodeData } from "../utils/axios";

export const fetchDocPerKind = async () => {
  const res = await axios.get("/docPerKind").catch((error) => {
    if (error.response) {
      console.error(error);
    }
  });

  return res.data;
};

export const fetchDocPerSpecificKind = async (id) => {
  const res = await axios
    .get("/docPerKind/withApplId", { params: { id } })
    .catch((error) => {
      if (error.response) {
        console.error(error);
      }
    });
  return res.data;
};

export const createDocPerKind = async (newDocPerKind) => {
  await axios.post("/docPerKind/create", encodeData(newDocPerKind));
};

export const updateDocPerKind = async (updatedDocPerKind) => {
  await axios.put("/docPerKind/update", encodeData(updatedDocPerKind));
};

export const deleteDocPerKind = async (oldDocPerKind) => {
  await axios.delete("/docPerKind/delete", { data: encodeData(oldDocPerKind) });
};
